import { useAuth } from "@clerk/clerk-react";
import { Separator } from "@radix-ui/react-separator";
import Transitions from "Components/Transitions/Transitions";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllNotifications,
  markAllAsRead,
} from "../../Redux/Notifications/NotificationsAction";
import { Skeleton } from "Components/ui/skeleton";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { useTheme } from "hooks/ThemeContext";

function NotificationPage() {
  const { theme } = useTheme();
  const { getToken } = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllNotifications(getToken));
    dispatch(markAllAsRead(getToken));
  }, []);

  const {
    notifications,
    getNotificationLoading,
    getNotificationError,
    markAllAsReadError,
  } = useSelector((state) => state.NotificationsReducer);

  useEffect(() => {
    if (getNotificationError) {
      toast.error(getNotificationError, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
    }
    if (markAllAsReadError) {
      toast.error(markAllAsReadError, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
    }
  }, [getNotificationError, markAllAsReadError]);
  return (
    <div
      className={`w-full h-full ${
        Object.keys(notifications)?.length == 0 && "overflow-hidden"
      }`}
    >
      <div className="text-2xl font-N_Medium">Notifications</div>
      <div className=" relative h-full">
        {getNotificationLoading ? (
          <div className="space-y-4 p-6 bg-background rounded-lg mt-6">
            <Skeleton className="h-7 w-36 " />
            {Array.from({ length: 3 }).map((_, i) => (
              <div
                key={i}
                className="flex items-center justify-between py-4 border-b-2 border-border-darkNew"
              >
                <div className="space-y-2">
                  <Skeleton className="h-5 w-32 " />
                  <Skeleton className="h-4 w-40 " />
                </div>
                <Skeleton className="h-4 w-16 " />
              </div>
            ))}
          </div>
        ) : (
          <div
            className={`bg-background p-6 rounded-lg flex-col flex  gap-12 mt-6 ${
              Object.keys(notifications)?.length == 0 && "h-full"
            } max-h-[70vh] overflow-y-auto hideScrollBar`}
          >
            {Object.keys(notifications)?.length > 0
              ? Object.keys(notifications).map((key) => (
                  <div className="flex-col gap-2 flex">
                    <div className="text-xl font-N_Medium mb-4">
                      {new Date(key).toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })}
                    </div>
                    <div className="flex-col gap-4 flex">
                      {notifications[key].map((item) => (
                        <div className="flex-col gap-4 flex">
                          <div className="flex justify-between items-center">
                            <div>
                              <div className="text-base font-N_Medium">
                                {item.title}
                              </div>
                              <div className="text-sm text-white-opacity font-N_Roman">
                                {item.description}
                              </div>
                            </div>
                            <div>
                              <div className="text-xs text-white-opacity font-N_Roman">
                                {new Date(item.createdAt).toLocaleTimeString(
                                  "en-US",
                                  {
                                    hour: "numeric",
                                    minute: "numeric",
                                  }
                                )}
                              </div>
                            </div>
                          </div>
                          <Separator className="bg-borderChallenge w-full opacity-20 h-[0.1rem] rounded-xl" />
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              : !getNotificationLoading && (
                  <div className="text-base text-white-opacity h-full flex flex-col gap-0 items-center justify-center cursor-pointer ">
                    <Bell color="var(--white-opacity)" size={"4rem"} />
                    <div className="font-N_Medium text-2xl ">
                      No Notifications yet!
                    </div>
                    <div className="font-N_Light text-base w-full max-w-[18rem]  text-center">
                      Stay tuned for important updates and alerts.
                    </div>
                  </div>
                )}
          </div>
        )}
        {Object.keys(notifications)?.length > 0 && (
          <div
            className={`absolute bottom-0 ${
              theme === "dark" && "gradient_overlay"
            } w-full h-[10rem] rounded-2xl`}
          ></div>
        )}
      </div>
    </div>
  );
}

export default NotificationPage;
